export default __webpack_public_path__ + "6879b329b6d286a97adb03b0e75646b4.png";